import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import PropTypes from 'prop-types';
import RowDisplay from '../common/RowDisplay';
import { useFindClientAliases } from './hooks/useFindClientAliases';
import Spinner from '../common/spinners/Spinner';
export var ExternalIdentifiers = function ExternalIdentifiers(_ref) {
  var contact = _ref.contact,
    groupId = _ref.groupId;
  var _useFindClientAliases = useFindClientAliases(contact.id, groupId),
    aliases = _useFindClientAliases.aliases,
    isLoading = _useFindClientAliases.isLoading;
  return /*#__PURE__*/React.createElement("div", {
    className: "row mb-one"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("h3", null, "External Identifiers"), isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : aliases === null || aliases === void 0 ? void 0 : _mapInstanceProperty(aliases).call(aliases, function (alias) {
    var _context;
    return /*#__PURE__*/React.createElement(RowDisplay, {
      label: alias.config_name,
      key: _concatInstanceProperty(_context = "".concat(alias.id, "-")).call(_context, alias.priority)
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 mt-1"
    }, alias.foreign_id));
  })));
};
ExternalIdentifiers.propTypes = {
  contact: PropTypes.object.isRequired,
  groupId: PropTypes.string.isRequired
};
export default ExternalIdentifiers;
//# sourceMappingURL=index.js.map